<template>
  <div class="mb-2" :class="{ 'text': !active, 'text-active': active }">
    <p>{{ author.name }}</p>
    <p v-if="author.parlamentar_name">Nome Parlamentar: {{ author.parlamentar_name }}</p>
    <!--<p>{{ author.legislatures }}</p>-->
  </div>
</template>

<script>
export default {
  name: "Author",
  props: {
    author: {
      type: Object,
      require: true
    },
    active: Boolean
  }
}
</script>

<style scoped>

</style>
